import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { store } from "../../services/service";
import { useRoleStore } from "../../store/RoleStore";
import { useStoreUser } from "../../store/user";
import { EDIT_PROFIL } from "../../Utils/constant";
import { SubmitButton } from "../Widget/SubmitButton";

export const EditProfil = ({ item }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState(null);
  const [select, setSelect] = useState(item?.roles[0]);
  const role = useRoleStore();
  const users = useStoreUser();

  const submit = (data) => {
    setIsSubmit(true);
    store(`${EDIT_PROFIL}`, "application/json", {
      ...data,
      username: item?.username,
    })
      .then((res) => {
        reset();
        setIsSubmit(false);
        if (res.status === 200) {
          users.user({ page: 0, param: "", size: 10 }, "&role=");
          toast.success("Profil modifié");
          document.getElementById(`fermer-profile${item?.id}`).click();
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setError(err?.response?.data?.donnee);
      });
  };

  useEffect(() => {
    if (item) {
      setSelect(item?.roles[0]);
      reset({
        role: item?.roles[0],
      });
    }
  }, [item, reset]);

  return (
    <form onSubmit={handleSubmit(submit)} className="w-full mb-8">
      <p className="text-sm text-red-600">{error}</p>
      <div className="my-2">
        <label htmlFor="" className="text-sm font-medium">
          Role <span className="text-red-500">*</span>
        </label>
        <select
          {...register("role", { required: true })}
          value={select}
          onChange={(e) => {
            setError(null);
            setSelect(e.target.value);
          }}
          className="select select-bordered w-full h-10"
        >
          <option value={""}>Choisissez un role</option>
          {role?.data?.map((item) => (
            <option className="capitalize" value={item.id}>
              {item?.id
                ?.replace(/ROLE_/g, " ")
                .replace(/_/g, " ")
                .toLowerCase()}
            </option>
          ))}
        </select>
      </div>

      {select === "ROLE_COMMERCIALE" ? (
        <div className="my-2">
          <label htmlFor="" className="text-sm font-medium">
            Type d'agent <span className="text-red-500">*</span>
          </label>
          <select
            {...register("typeAgent", { required: true })}
            className="select select-bordered w-full h-10"
          >
            <option value={""} disabled selected>
              Selectionnez un type
            </option>
            <option value="COMMERCIAL_DOOR_TO_DOOR">
              Door to Door (Porte à porte)
            </option>
            <option value="COMMERCIAL_AGENCE">En agence</option>
          </select>
        </div>
      ) : null}
      <SubmitButton isSubmit={isSubmit} label={"modifier le profil"} />
    </form>
  );
};
